module.exports = __webpack_public_path__ + "media/images/logo-dark-4ab735af478ae1907853ebc1684efcb1.svg";